/**
 * Wraps `onOpenChange` with a confirm-on-close guard. Returns a handler that
 * blocks closing while either the standard-tab footer slot reports dirty +
 * not applying, or the drawer's CUSTOM config draft (`configDirty`) has
 * unsaved edits (mode toggle, formula groups, exclusion rules). Passes
 * through every other state change unchanged.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { useCallback } from 'react';

import { useFlowOptimizerDrawerFooter } from './FlowOptimizerDrawerFooterContext';

const CONFIRM_MESSAGE =
  'You have unsaved changes. Close the drawer and lose them?';

export function useDirtyCloseGuard(
  onOpenChange: (open: boolean) => void,
  configDirty = false,
): (open: boolean) => void {
  const { slot } = useFlowOptimizerDrawerFooter();
  return useCallback(
    (open: boolean) => {
      const slotDirty = Boolean(slot?.dirty && !slot.applying);
      if (!open && (slotDirty || configDirty)) {
        if (!window.confirm(CONFIRM_MESSAGE)) return;
      }
      onOpenChange(open);
    },
    [onOpenChange, slot?.dirty, slot?.applying, configDirty],
  );
}
